export interface CriteriaItem {
  id: string;
  title: string;
  description: string;
  assessmentPoints: string[];
  weightage: number;
}

export const innovationReviewCriteria: CriteriaItem[] = [
  {
    id: 'novelty-uniqueness',
    title: '1. Novelty & Uniqueness',
    description: 'Evaluate the innovation\'s originality and uniqueness for Intellectual Property protection',
    assessmentPoints: [
      'Degree of innovation (incremental vs. breakthrough)',
      'Unique elements and differentiation from existing solutions',
      'Prior art and existing solutions comparison',
      'Technology readiness level (TRL)',
      'Proprietary elements and defensibility',
      'Freedom to operate (FTO) considerations',
      'Novelty assessment for patent potential'
    ],
    weightage: 35
  },
  {
    id: 'technical-feasibility',
    title: '2. Technical Feasibility & Implementation',
    description: 'Evaluate the technical soundness and implementation readiness',
    assessmentPoints: [
      'Technical soundness and scientific validity',
      'Development stage and readiness (Prototype/Pilot/Market-ready)',
      'Scalability and manufacturing capability',
      'Technical risks and mitigation strategies',
      'Technical documentation completeness',
      'Technical team capability and expertise',
      'Reproducibility and consistency of results'
    ],
    weightage: 25
  },
  {
    id: 'ip-protection',
    title: '3. Intellectual Property Protection Potential',
    description: 'Evaluate the Intellectual Property protection opportunities and strategies',
    assessmentPoints: [
      'Patentability assessment (novelty, non-obviousness, utility)',
      'Scope of potential patent claims',
      'Trademark and brand protection opportunities',
      'Copyright protection for software/content',
      'Industrial Design protection potential',
      'International Intellectual Property filing strategy (PCT, regional)',
      'Intellectual Property ownership clarity and assignment',
      'Prior art search and Freedom to Operate analysis'
    ],
    weightage: 30
  },
  {
    id: 'impact-potential',
    title: '4. Impact Potential & Application',
    description: 'Assess the broader impact and application value',
    assessmentPoints: [
      'Societal impact and benefit to end users',
      'Problem-solving effectiveness',
      'Environmental sustainability considerations',
      'Alignment with national/regional innovation priorities',
      'Scalability to multiple applications or sectors',
      'Potential for follow-on innovations',
      'Strategic value to stakeholders'
    ],
    weightage: 10
  }
];

export const ipProtectionTypes = [
  {
    type: 'Patent',
    description: 'Protects functional inventions, processes, and systems',
    suitable: 'Technical innovations with novel functionality, processes, or methods',
    duration: '20 years from filing date',
    considerations: 'Requires novelty, non-obviousness, and utility. Provides strong protection for inventions.',
    requiredDocuments: [
      'Detailed technical specifications',
      'Claims defining the invention',
      'Prior art search results',
      'Drawings and diagrams',
      'Inventor declarations'
    ],
    estimatedCost: 'Variable (e.g., KES 150,000 - 500,000)'
  },
  {
    type: 'Trademark',
    description: 'Protects brand names, logos, and distinctive marks',
    suitable: 'Brand identity, product names, and distinctive identifiers',
    duration: '10 years, renewable indefinitely',
    considerations: 'Protects brand identity and market recognition. Does not protect the invention itself.',
    requiredDocuments: [
      'Trademark specimen/logo',
      'Description of goods/services',
      'Proof of use in commerce',
      'Trademark search report'
    ],
    estimatedCost: 'Variable (e.g., KES 25,000 - 100,000)'
  },
  {
    type: 'Copyright',
    description: 'Protects original works of authorship',
    suitable: 'Software code, written content, artistic works, documentation',
    duration: 'Life of author + 70 years',
    considerations: 'Automatic protection upon creation. Does not protect ideas or functionality, only expression.',
    requiredDocuments: [
      'Copy of the work',
      'Author information',
      'Creation date documentation',
      'Ownership proof'
    ],
    estimatedCost: 'Variable (e.g., KES 10,000 - 50,000)'
  },
  {
    type: 'Industrial Design',
    description: 'Protects ornamental or aesthetic aspects of functional items',
    suitable: 'Unique visual designs, product shapes, patterns, and configurations',
    duration: '15 years from grant date',
    considerations: 'Protects appearance and aesthetics, not function. Must be novel and original.',
    requiredDocuments: [
      'Design drawings/photographs',
      'Multiple view representations',
      'Description of design features',
      'Novelty statement'
    ],
    estimatedCost: 'Variable (e.g., KES 75,000 - 200,000)'
  }
];
